import React from 'react';
import './Termine.css';


export const Termine = () => {
	



	return (
		<section id="events">

                <div className='text-card-container'>
                <h1 className='section-header'>Termine</h1>

                    

                <div className="col-sm-12">
						<ul>
							<li>
								<strong>Sonntags:</strong> 9:00–10:00 Uhr – Panzerwiese
								(Spendenbasis)
							</li>
							<li>
								<strong>Mittwochs:</strong> 18:45–19:45 Uhr – Bonner Platz 1,
								Zentrum für Yoga und Gesundheit <a href="https://www.fyndery.de/muenchen/kurs/50329/kundalini-yoga-in-muenchen-nervensystem-staerken-k/?ref=42338" target="_blank" rel="noopener noreferrer">HIER BUCHEN</a>
							</li>
						</ul>
					</div>

					</div>

        </section>
	);


}